import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { MetricsDisplayGridRowDataFragmentGql } from './MetricsDisplayGridRowDataFragmentGql';

export const VirtualConnectionDownstreamMetricsQueryGql: DocumentNode = gql`
query VirtualConnectionDownstreamMetricsQuery(
  $vizportalUrlId: String!,
  $first: Int!,
  $offset:
  Int!,
  $orderBy: MetricSortOrder!
) {
  virtualConnections(filter: { vizportalUrlId: $vizportalUrlId }) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowDataFragment
      }
    }
  }
}
${MetricsDisplayGridRowDataFragmentGql}
`;
